import { render, staticRenderFns } from "./AssignmentGrid.vue?vue&type=template&id=3e8224a3&"
import script from "./AssignmentGrid.vue?vue&type=script&lang=js&"
export * from "./AssignmentGrid.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports